module.exports = __webpack_public_path__ + "img/2.673aebbb.png";